import React from "react";
import {Tooltip, useTheme} from "@mui/material";
import {editCellPadding} from "../../../../misc/scroller/TableEditCell";

// shows whether a drw door elevation has thermal glass. The elevation tool's glass "Thermal"
// checkbox sets it, so the grid does not edit it. The input is not disabled, so a checked box
// keeps the primary color; pointer events are off instead.
export function DrwDoorThermalCheckbox(props: {checked: boolean}) {
    const theme = useTheme();

    return (
        <Tooltip title="Thermal — set in the elevation tool">
            <div style={{
                position: "absolute", top: 0, right: 2, width: 20, zIndex: 2,
                display: "flex", justifyContent: "center",
                height: 20,
                marginTop: -editCellPadding.top - 2,
                marginBottom: -editCellPadding.bottom - 2,
            }}>
                <input
                    type="checkbox"
                    checked={props.checked}
                    readOnly
                    tabIndex={-1}
                    style={{pointerEvents: "none", accentColor: theme.palette.primary.main}}
                />
            </div>
        </Tooltip>
    );
}
